import { render, staticRenderFns } from "./iam-list-page.vue?vue&type=template&id=4640a4b0&scoped=true&"
import script from "./iam-list-page.vue?vue&type=script&lang=js&"
export * from "./iam-list-page.vue?vue&type=script&lang=js&"
import style0 from "./iam-list-page.vue?vue&type=style&index=0&id=4640a4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640a4b0",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn})
